import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const CopyMealPlanToWeekSelector = ({
  currentTemplate,
  selectedCurrentTemplateWeeks,
  updateState,
}) => {
  /**
   * Handle the selected weeks
   * @param {*} index
   */
  const handleSelectionChangeForCurrentPlanWeeks = (index) => {
    updateState({
      selectedCurrentTemplateWeeks: selectedCurrentTemplateWeeks.includes(index)
        ? selectedCurrentTemplateWeeks.filter((week) => week !== index)
        : [...selectedCurrentTemplateWeeks, index],
    });
  };

  const { t } = useTranslation("coaching-portal");
  return (
    <div className="body">
      <div className="weeks-container">
        <label>{t("allTemplates.copyMealPlanTo.selectWeek")}</label>
        <div className="week-list">
          <ul>
            {currentTemplate?.weeks.map(({}, index) => (
              <li key={`${currentTemplate?._id}-${index}`}>
                <SvgIcon
                  onClick={() =>
                    handleSelectionChangeForCurrentPlanWeeks(index)
                  }
                  src={`/img/new-icons/${
                    selectedCurrentTemplateWeeks.includes(index)
                      ? "checked-square.svg"
                      : "unchecked-square.svg"
                  }`}
                  noFilterOnLight={selectedCurrentTemplateWeeks.includes(index)}
                />
                <span>{t("allTemplates.copyMealPlanTo.week")} {index + 1}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

CopyMealPlanToWeekSelector.propTypes = {
  currentTemplate: PropTypes.object,
  selectedCurrentTemplateWeeks: PropTypes.array,
  updateState: PropTypes.func,
};

export default CopyMealPlanToWeekSelector;
